import store from '@/store'
export default{
    inserted(el, binding, vnode) {
        const { value } = binding //绑定的值
        const all_permission = "*:*:*";//拥有所有权限的值
        //得到用户拥有的权限
        const permissions = store.getters && store.getters.permissions      
        
        //
        if (value && value instanceof Array && value.length > 0) {
          const permissionFlag = value //所需要的权限
    
          const hasPermissions = permissions.some(permission => {
            return all_permission === permission || permissionFlag.includes(permission)
          })
         
          // 没有权限->删除el
          if (!hasPermissions) {
            el.parentNode && el.parentNode.removeChild(el)
          }
        } else {
          throw new Error(`请设置操作权限标签值`)
        }
      }
    
}